module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "approval-list-container"
  }, [(_vm.isBusy) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('b-card', {
    staticClass: "border-0 shadow-sm",
    staticStyle: {
      "border-radius": "8px",
      "overflow": "hidden"
    },
    attrs: {
      "no-body": ""
    }
  }, [_c('b-tabs', {
    attrs: {
      "card": "",
      "pills": ""
    },
    on: {
      "input": _vm.onTabChange
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "All Profit Loss List"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Approved"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Mismatch"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Pending"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Billing Locked"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Profit"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": 'Profit ' + _vm.perCon + ' ' + _vm.perVal + '%'
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Profit Locked"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Loss"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": 'Loss ' + _vm.perCon + ' ' + _vm.perVal + '%'
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Loss Locked"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Normal"
    }
  })], 1), _vm._v(" "), (_vm.pageType == 'Profit_less_15' || _vm.pageType == 'Loss_less_15') ? _c('b-row', {
    staticClass: "mb-3 ml-2 mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Condition")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.perCondList,
      "option-value": "perVal",
      "option-text": "perText",
      "placeholder": "Select Condition"
    },
    on: {
      "input": _vm.getData
    },
    model: {
      value: (_vm.perCon),
      callback: function($$v) {
        _vm.perCon = $$v
      },
      expression: "perCon"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Condition Value")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "Search Condition Value"
    },
    on: {
      "input": _vm.getData
    },
    model: {
      value: (_vm.perVal),
      callback: function($$v) {
        _vm.perVal = $$v
      },
      expression: "perVal"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-card-header', {
    staticClass: "bg-white border-bottom p-4"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-3"
  }, [_c('h4', {
    staticClass: "mb-0 text-primary font-weight-bold"
  }, [_c('i', {
    staticClass: "fa fa-check-circle mr-2"
  }), _vm._v("Profit / Loss Approvals\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-input-group', {
    staticClass: "mr-3",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('b-input-group-prepend', {
    staticClass: "bg-light border-right-0",
    attrs: {
      "is-text": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-search text-muted"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "border-left-0 bg-light",
    attrs: {
      "placeholder": "Search by Job No, Billing Party..."
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), (_vm.filter) ? _c('b-input-group-append', [_c('b-button', {
    staticClass: "text-muted",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "variant": "link"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.getData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Refresh\n          ")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-success"
    },
    on: {
      "click": _vm.exportToExcel
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Export\n          ")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.showBulkUploadModal
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Bulk Upload\n          ")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "info"
    },
    on: {
      "click": _vm.openHistoryModal
    }
  }, [_c('i', {
    staticClass: "fa fa-history"
  }), _vm._v(" Entry History\n          ")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.filter-collapse",
      modifiers: {
        "filter-collapse": true
      }
    }],
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-secondary"
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filters\n          ")])], 1)]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "filter-collapse"
    },
    model: {
      value: (_vm.filtersVisible),
      callback: function($$v) {
        _vm.filtersVisible = $$v
      },
      expression: "filtersVisible"
    }
  }, [_c('b-card', {
    staticClass: "bg-light border-0 mb-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    staticClass: "small text-muted font-weight-bold"
  }, [_vm._v("Date Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.dateTypeOptions,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Date Type"
    },
    on: {
      "input": _vm.onFilterChange
    },
    model: {
      value: (_vm.filters.dateType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "dateType", $$v)
      },
      expression: "filters.dateType"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    staticClass: "small text-muted font-weight-bold"
  }, [_vm._v("Date Range")]), _vm._v(" "), _c('date-range-picker', {
    ref: "picker",
    staticClass: "w-100",
    attrs: {
      "opens": _vm.openLeft,
      "startDate": _vm.dateRange.startDate,
      "endDate": _vm.dateRange.endDate
    },
    on: {
      "update": _vm.onFilterChange
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function(picker) {
        return [_c('div', {
          staticClass: "d-flex align-items-center form-control",
          staticStyle: {
            "min-width": "250px"
          }
        }, [_c('i', {
          staticClass: "fa fa-calendar mr-2 text-muted"
        }), _vm._v(" "), (picker.startDate && picker.endDate) ? _c('span', [_vm._v("\n                                      " + _vm._s(_vm.moment(picker.startDate).format('DD/MM/YYYY')) + " - " + _vm._s(_vm.moment(picker.endDate).format('DD/MM/YYYY')) + "\n                                  ")]) : _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Select Date Range")]), _vm._v(" "), _c('i', {
          staticClass: "fa fa-caret-down ml-auto text-muted"
        })])]
      }
    }]),
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    staticClass: "small text-muted font-weight-bold"
  }, [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Branch"
    },
    on: {
      "input": _vm.onFilterChange
    },
    model: {
      value: (_vm.filters.branchfilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "branchfilter", $$v)
      },
      expression: "filters.branchfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    staticClass: "small text-muted font-weight-bold"
  }, [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client"
    },
    on: {
      "input": _vm.onFilterChange
    },
    model: {
      value: (_vm.filters.clientFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "clientFilter", $$v)
      },
      expression: "filters.clientFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    staticClass: "small text-muted font-weight-bold"
  }, [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "input": _vm.onFilterChange
    },
    model: {
      value: (_vm.filters.slineFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "slineFilter", $$v)
      },
      expression: "filters.slineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    staticClass: "small text-muted font-weight-bold"
  }, [_vm._v("User")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select User"
    },
    on: {
      "input": _vm.onFilterChange
    },
    model: {
      value: (_vm.filters.userFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "userFilter", $$v)
      },
      expression: "filters.userFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    staticClass: "small text-muted font-weight-bold"
  }, [_vm._v("Transport Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.transportOptions,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Transport Type"
    },
    on: {
      "input": _vm.onFilterChange
    },
    model: {
      value: (_vm.filters.transportType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "transportType", $$v)
      },
      expression: "filters.transportType"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    staticClass: "small text-muted font-weight-bold"
  }, [_vm._v("Remark")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllRemarkDDList'],
      "option-value": "label",
      "option-text": "label",
      "placeholder": "Search & Select Remark"
    },
    on: {
      "searchchange": _vm.searchRemark,
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filters.remarkFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "remarkFilter", $$v)
      },
      expression: "filters.remarkFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "d-flex align-items-end mb-3",
    attrs: {
      "md": "3"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-danger",
      "size": "sm",
      "block": ""
    },
    on: {
      "click": _vm.clearFilters
    }
  }, [_c('i', {
    staticClass: "fa fa-times mr-1"
  }), _vm._v(" Clear Filters\n                       ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-card-body', {
    staticClass: "p-0"
  }, [_c('b-row', {
    staticClass: "mx-3 mt-3 mb-2"
  }, [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-card', {
    staticClass: "shadow-sm border-0 summary-card"
  }, [_c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Total Expense Amt")]), _vm._v(" "), _c('div', {
    staticClass: "h5 mb-0 font-weight-bold text-danger"
  }, [_vm._v("\n                          " + _vm._s(_vm.formatSummaryAmount(_vm.totalExpenseAmt)) + "\n                      ")])])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-card', {
    staticClass: "shadow-sm border-0 summary-card"
  }, [_c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Total Inv Amt")]), _vm._v(" "), _c('div', {
    staticClass: "h5 mb-0 font-weight-bold text-primary"
  }, [_vm._v("\n                          " + _vm._s(_vm.formatSummaryAmount(_vm.totalInvAmt)) + "\n                      ")])])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-card', {
    staticClass: "shadow-sm border-0 summary-card"
  }, [_c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Total Profit")]), _vm._v(" "), _c('div', {
    staticClass: "h5 mb-0 font-weight-bold",
    class: _vm.totalProfit >= 0 ? 'text-success' : 'text-danger'
  }, [_vm._v("\n                          " + _vm._s(_vm.formatSummaryAmount(_vm.totalProfit)) + "\n                      ")])])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-card', {
    staticClass: "shadow-sm border-0 summary-card"
  }, [_c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Total Profit %")]), _vm._v(" "), _c('div', {
    staticClass: "h5 mb-0 font-weight-bold",
    class: _vm.totalProfitPercent >= 0 ? 'text-success' : 'text-danger'
  }, [_vm._v("\n                          " + _vm._s(_vm.formatSummaryPercent(_vm.totalProfitPercent)) + "\n                      ")])])], 1)], 1), _vm._v(" "), _c('b-table', {
    staticClass: "mb-0 custom-table",
    attrs: {
      "items": _vm.items,
      "fields": _vm.fields,
      "responsive": "",
      "show-empty": "",
      "hover": "",
      "head-variant": "light"
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row) {
        return [_c('span', [_vm._v(_vm._s(row.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "JobNo",
      fn: function(row) {
        return [_c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "truncate-text",
          attrs: {
            "title": row.item.JobNo || row.item.SalesSeries
          }
        }, [_vm._v("Job No : " + _vm._s(_vm.truncateWithEllipsis(row.item.JobNo || row.item.SalesSeries, 15)))]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "truncate-text",
          attrs: {
            "title": row.item.JobDate
          }
        }, [_vm._v("Job Date : " + _vm._s(row.item.JobDate))]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "truncate-text",
          attrs: {
            "title": row.item.RaisedBy
          }
        }, [_vm._v("Raised By : " + _vm._s(_vm.truncateWithEllipsis(row.item.RaisedBy, 15)))]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "truncate-text",
          attrs: {
            "title": row.item.RasiedFrom
          }
        }, [_vm._v("Raised From : " + _vm._s(_vm.truncateWithEllipsis(row.item.RasiedFrom, 15)))]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "truncate-text",
          attrs: {
            "title": row.item.vessel_voyage
          }
        }, [_vm._v("Vessel : " + _vm._s(_vm.truncateWithEllipsis(row.item.vessel_voyage, 15)))]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "truncate-text",
          attrs: {
            "title": row.item.HBLNO
          }
        }, [_vm._v("Hbl No : " + _vm._s(_vm.truncateWithEllipsis(row.item.HBLNO, 15)))]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "truncate-text",
          attrs: {
            "title": row.item.MBLNO
          }
        }, [_vm._v("Mbl No : " + _vm._s(_vm.truncateWithEllipsis(row.item.MBLNO, 15)))])]
      }
    }, {
      key: "Profit",
      fn: function(row) {
        return [_c('div', {
          staticClass: "text-nowrap"
        }, [_c('span', {
          staticClass: "font-weight-bold",
          class: row.item.Profit >= 0 ? 'text-success' : 'text-danger'
        }, [_vm._v("\n                          " + _vm._s(row.item.Profit) + "\n                      ")])])]
      }
    }, {
      key: "ProfitPercent",
      fn: function(row) {
        return [_c('div', {
          staticClass: "text-nowrap"
        }, [_c('span', {
          staticClass: "font-weight-bold",
          class: row.item.ProfitPercent >= 0 ? 'text-success' : 'text-danger'
        }, [_vm._v("\n                          " + _vm._s(row.item.ProfitPercent) + "%\n                      ")])])]
      }
    }, {
      key: "IsMismatch",
      fn: function(row) {
        return [_c('b-badge', {
          staticClass: "p-2 px-3 badge-pill",
          attrs: {
            "variant": row.item.IsMismatch ? 'warning' : 'success'
          }
        }, [_vm._v("\n                      " + _vm._s(row.item.IsMismatch ? 'Yes' : 'No') + "\n                  ")])]
      }
    }, {
      key: "POR",
      fn: function(row) {
        return [_c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "truncate-text",
          attrs: {
            "title": row.item.POR
          }
        }, [_vm._v("POR : " + _vm._s(_vm.truncateWithEllipsis(row.item.POR, 15)))]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "truncate-text",
          attrs: {
            "title": row.item.POL
          }
        }, [_vm._v("POL : " + _vm._s(_vm.truncateWithEllipsis(row.item.POL, 15)))]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "truncate-text",
          attrs: {
            "title": row.item.POD
          }
        }, [_vm._v("POD : " + _vm._s(_vm.truncateWithEllipsis(row.item.POD, 15)))]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "truncate-text",
          attrs: {
            "title": row.item.FPOD
          }
        }, [_vm._v("FPOD : " + _vm._s(_vm.truncateWithEllipsis(row.item.FPOD, 15)))]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "truncate-text",
          attrs: {
            "title": row.item.PICK
          }
        }, [_vm._v("PICK : " + _vm._s(_vm.truncateWithEllipsis(row.item.PICK, 15)))]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "truncate-text",
          attrs: {
            "title": row.item.STUFF
          }
        }, [_vm._v("STUFF : " + _vm._s(_vm.truncateWithEllipsis(row.item.STUFF, 15)))]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "truncate-text",
          attrs: {
            "title": row.item.HAND
          }
        }, [_vm._v("HAND : " + _vm._s(_vm.truncateWithEllipsis(row.item.HAND, 15)))])]
      }
    }, {
      key: "clientName",
      fn: function(row) {
        return [_c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "truncate-text",
          attrs: {
            "title": row.item.clientName
          }
        }, [_vm._v("\n                     Client : " + _vm._s(_vm.truncateWithEllipsis(row.item.clientName, 15))), _c('br')]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "truncate-text",
          attrs: {
            "title": row.item.shippingLine
          }
        }, [_vm._v("  Sline : " + _vm._s(_vm.truncateWithEllipsis(row.item.shippingLine, 15))), _c('br')]), _vm._v(" "), _c('span', {
          staticClass: "font-weight-bold text-dark"
        }, [_vm._v("Mbl Date : ")]), _vm._v(_vm._s(row.item.MblDate)), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "font-weight-bold text-dark"
        }, [_vm._v("Mbl Release Date : ")]), _vm._v(_vm._s(row.item.MblReleaseDate)), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "font-weight-bold text-dark"
        }, [_vm._v("SOB : ")]), _vm._v(_vm._s(row.item.Sob)), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "font-weight-bold text-dark"
        }, [_vm._v("EtaEstimated : ")]), _vm._v(_vm._s(row.item.EtaEstimated)), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "font-weight-bold text-dark"
        }, [_vm._v("EtaActual : ")]), _vm._v(_vm._s(row.item.EtaActual)), _c('br')]
      }
    }, {
      key: "Remarks",
      fn: function(row) {
        return [_c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "truncate-text",
          attrs: {
            "title": row.item.Remarks
          }
        }, [_vm._v("\n                      " + _vm._s(_vm.truncateWithEllipsis(row.item.Remarks, 15)) + "\n                  ")])]
      }
    }, {
      key: "Description",
      fn: function(row) {
        return [_c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "truncate-text",
          attrs: {
            "title": row.item.Description
          }
        }, [_vm._v("\n                      " + _vm._s(_vm.truncateWithEllipsis(row.item.Description, 15)) + "\n                  ")])]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [_c('div', {
          staticClass: "d-flex flex-column"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-1"
        }, [_c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "mr-1 btn-action",
          attrs: {
            "size": "sm",
            "variant": "outline-info",
            "title": "Summary & Documents"
          },
          on: {
            "click": function($event) {
              _vm.openModal('doc', row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-text"
        })]), _vm._v(" "), (row.item.allModuleId) ? _c('JobWisePaymentsDetails', {
          attrs: {
            "allModuleId": Number(row.item.allModuleId),
            "JobNo": row.item.JobNo,
            "isIcon": true,
            "iconClass": "fa fa-money"
          }
        }) : _vm._e(), _vm._v(" "), (row.item.allModuleId) ? _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking',
            "assign_date": _vm.moment(row.item.CreatedTime).format('DD/MM/YYYY'),
            "assign_job_type": row.item.jobType || '',
            "assign_raised_from": 'Raised From: ' + (row.item.BranchName || ''),
            "assign_raised_by": 'Raised By: ' + (row.item.CreatedBy || ''),
            "fk_all_module_id": row.item.allModuleId,
            "jb_series": row.item.JobNo,
            "fk_client_id": row.item.clientId,
            "fk_pod_id": row.item.PODLocationId,
            "isIcon": true,
            "iconClass": "fa fa-truck"
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "d-flex align-items-center"
        }, [(row.item.allModuleId) ? _c('InvExpSummary', {
          attrs: {
            "PMC_title": 'Inv Exp Summary Job No - ' + row.item.JobNo,
            "PMC_JOBID": String(row.item.allModuleId),
            "PMC_JOBNO": row.item.JobNo,
            "PMC_JOBDATE": _vm.moment(row.item.CreatedTime).format('DD/MM/YYYY'),
            "PMC_JOBTYPE": row.item.jobType || '',
            "PMC_AgentType": '',
            "PMC_Client": row.item.BillingParty,
            "PMC_Sline": row.item.shippingLine || '',
            "isIcon": true,
            "iconClass": "fa fa-list-alt"
          }
        }) : _vm._e(), _vm._v(" "), (row.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row.item.JobNo,
            "PMC_JOBID": String(row.item.allModuleId),
            "PMC_JOBNO": row.item.JobNo,
            "PMC_JOBDATE": _vm.moment(row.item.CreatedTime).format('DD/MM/YYYY'),
            "PMC_JOBTYPE": row.item.jobType || '',
            "PMC_AgentType": '',
            "PMC_Client": row.item.BillingParty,
            "PMC_Sline": row.item.shippingLine || '',
            "isIcon": true,
            "iconClass": "fa fa-cube"
          }
        }) : _vm._e(), _vm._v(" "), _c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "mr-1 btn-action",
          attrs: {
            "size": "sm",
            "variant": "outline-success",
            "title": "Approve"
          },
          on: {
            "click": function($event) {
              _vm.approve(row.item, row.index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-check"
        })]), _vm._v(" "), _c('ProfitLossLogModal', {
          attrs: {
            "PMC_JOBID": String(row.item.id || row.item.fk_pl_id || row.item.pl_id || row.item.pla_id || ''),
            "PMC_JOBNO": row.item.JobNo || row.item.SalesSeries,
            "PMC_title": 'Log Records',
            "clientName": row.item.BillingParty
          }
        })], 1)])]
      }
    }])
  }, [_c('template', {
    slot: "empty"
  }, [_c('div', {
    staticClass: "text-center text-muted my-5"
  }, [_c('i', {
    staticClass: "fa fa-inbox fa-3x mb-3"
  }), _vm._v(" "), _c('p', [_vm._v("No records found.")])])])], 2)], 1), _vm._v(" "), _c('b-card-footer', {
    staticClass: "bg-white border-top py-3"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "text-muted small"
  }, [_vm._v("\n               Showing " + _vm._s(_vm.items.length > 0 ? (_vm.currentPage - 1) * _vm.perPage + 1 : 0) + " to " + _vm._s(Math.min(_vm.currentPage * _vm.perPage, _vm.totalRows)) + " of " + _vm._s(_vm.totalRows) + " entries\n           ")]), _vm._v(" "), _c('b-pagination', {
    staticClass: "mb-0 custom-pagination",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "right",
      "pills": ""
    },
    on: {
      "change": _vm.onPageChange
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "visible": _vm.activeModal === 'doc',
      "size": "xl",
      "hide-footer": "",
      "title": "Summary & Documents"
    },
    on: {
      "hidden": function($event) {
        _vm.activeModal = null
      }
    }
  }, [(_vm.selectedItem && _vm.activeModal === 'doc') ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.selectedItem.allModuleId,
      "JOBSERIES": _vm.selectedItem.JobNo
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "visible": _vm.activeModal === 'approve',
      "title": "Approve Profit & Loss",
      "size": "md"
    },
    on: {
      "hidden": function($event) {
        _vm.activeModal = null
      }
    }
  }, [(_vm.selectedItem) ? _c('div', [_c('p', [_c('strong', [_vm._v("Job No:")]), _vm._v(" " + _vm._s(_vm.selectedItem.JobNo))]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "Standard Remarks"
    }
  }, [_c('CustomMultiSelect', {
    attrs: {
      "options": _vm.$store.getters['common/getAllRemarkDDList'],
      "selected-options": _vm.selectedStandardRemarksItems,
      "placeholder": "Search & Select Remark",
      "multiple": true
    },
    on: {
      "select": _vm.onStandardRemarkSelect
    },
    model: {
      value: (_vm.selectedStandardRemark),
      callback: function($$v) {
        _vm.selectedStandardRemark = $$v
      },
      expression: "selectedStandardRemark"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "Remarks (Optional)"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "placeholder": "Enter validation remarks...",
      "rows": "3",
      "max-rows": "6"
    },
    model: {
      value: (_vm.approvalRemarks),
      callback: function($$v) {
        _vm.approvalRemarks = $$v
      },
      expression: "approvalRemarks"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "modal-footer"
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.activeModal = null
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submitApproval
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Approve\n          ")])], 1)], 2), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Bulk Upload Profit Loss Remarks",
      "size": "lg",
      "hide-footer": ""
    },
    model: {
      value: (_vm.showBulkModal),
      callback: function($$v) {
        _vm.showBulkModal = $$v
      },
      expression: "showBulkModal"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-3"
  }, [_c('div', {
    staticClass: "flex-grow-1 mr-3"
  }, [_c('b-form-file', {
    attrs: {
      "state": Boolean(_vm.uploadFile),
      "placeholder": "Choose a file or drop it here...",
      "drop-placeholder": "Drop file here...",
      "accept": ".xlsx, .xls"
    },
    on: {
      "change": _vm.handleFileUpload
    },
    model: {
      value: (_vm.uploadFile),
      callback: function($$v) {
        _vm.uploadFile = $$v
      },
      expression: "uploadFile"
    }
  })], 1)]), _vm._v(" "), (_vm.uploadError) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "danger",
      "dismissible": ""
    },
    on: {
      "dismissed": function($event) {
        _vm.uploadError = ''
      }
    }
  }, [_vm._v(_vm._s(_vm.uploadError))]) : _vm._e(), _vm._v(" "), (_vm.uploadSuccess) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "success",
      "dismissible": ""
    },
    on: {
      "dismissed": function($event) {
        _vm.uploadSuccess = ''
      }
    }
  }, [_vm._v(_vm._s(_vm.uploadSuccess))]) : _vm._e(), _vm._v(" "), (_vm.uploadPreview.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_vm._v("Preview (" + _vm._s(_vm.uploadPreview.length) + " records)")]), _vm._v(" "), _c('b-table', {
    staticStyle: {
      "max-height": "300px",
      "overflow-y": "auto"
    },
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.uploadPreview,
      "fields": ['jobNo', 'remark', 'remark_description'],
      "small": "",
      "responsive": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right mt-2"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.uploadLoading
    },
    on: {
      "click": _vm.submitBulkUpload
    }
  }, [(_vm.uploadLoading) ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.uploadLoading ? 'Uploading...' : 'Submit Upload') + "\n          ")], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('ProfitLossHistoryModal', {
    ref: "historyModal"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd5500b4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/profitLoss/ProfitLossApprovalList.vue
// module id = 2883
// module chunks = 0